import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaymentStatus from "./Component/PaymentStatus";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import { PolicyCenter, StorePolicy } from "./Component/StorePolicies";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <a className="skip-link" href="#main-content">
          Skip to content
        </a>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/payments" element={<StorePolicy policyKey="payments" />} />
          <Route path="/order-changes" element={<StorePolicy policyKey="orders" />} />
          <Route path="/preorders" element={<StorePolicy policyKey="preorders" />} />
          <Route path="/warranty" element={<StorePolicy policyKey="warranty" />} />
          <Route path="/gift-cards" element={<StorePolicy policyKey="giftCards" />} />
          <Route path="/promotions" element={<StorePolicy policyKey="promotions" />} />
          <Route path="/accessibility" element={<StorePolicy policyKey="accessibility" />} />
          <Route path="/privacy-rights" element={<StorePolicy policyKey="privacyRights" />} />
          <Route path="/intellectual-property" element={<StorePolicy policyKey="intellectualProperty" />} />
          <Route path="/complaints" element={<StorePolicy policyKey="complaints" />} />
          <Route path="/product-safety" element={<StorePolicy policyKey="productSafety" />} />
          <Route path="/security" element={<StorePolicy policyKey="security" />} />
          <Route path="/sustainability" element={<StorePolicy policyKey="sustainability" />} />
          <Route path="/ethical-sourcing" element={<StorePolicy policyKey="ethicalSourcing" />} />
          <Route path="/legal-notice" element={<StorePolicy policyKey="legalNotice" />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaymentStatus />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
